import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Use environment variable or fallback to production URL
export const API = process.env.REACT_APP_BACKEND_URL 
  ? `${process.env.REACT_APP_BACKEND_URL}/api`
  : 'https://devisfast-backend.onrender.com/api';

export const formatCurrency = (amount) => {
  const num = parseFloat(amount);
  if (isNaN(num)) return '0,00 €';
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2
  }).format(num);
};

export const formatCurrencyPDF = (amount) => {
  const num = parseFloat(amount);
  if (isNaN(num)) return '0,00 €';
  const parts = num.toFixed(2).split('.');
  const intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  const decPart = parts[1];
  return intPart + ',' + decPart + ' €';
};

export const formatDate = (dateString) => {
  return new Intl.DateTimeFormat('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  }).format(new Date(dateString));
};

export const formatDateLong = (dateString) => {
  return new Intl.DateTimeFormat('fr-FR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  }).format(new Date(dateString));
};

export const STATUS_LABELS = {
  brouillon: 'Brouillon',
  envoye: 'Envoyé',
  accepte: 'Accepté',
  refuse: 'Refusé',
  expire: 'Expiré',
  'Signé': 'Signé'
};

export const STATUS_COLORS = {
  brouillon: 'bg-muted text-muted-foreground',
  envoye: 'bg-blue-500/20 text-blue-400',
  accepte: 'bg-green-500/20 text-green-400',
  refuse: 'bg-destructive/20 text-destructive',
  expire: 'bg-blue-900/20 text-blue-300',
  'Signé': 'bg-green-500/20 text-green-400'
};

// Invoice statuses
export const INVOICE_STATUS_LABELS = {
  brouillon: 'Brouillon',
  envoyee: 'Envoyée',
  payee: 'Payée',
  en_retard: 'En retard'
};

export const INVOICE_STATUS_COLORS = {
  brouillon: 'bg-muted text-muted-foreground',
  envoyee: 'bg-blue-500/20 text-blue-400',
  payee: 'bg-green-500/20 text-green-400',
  en_retard: 'bg-destructive/20 text-destructive'
};

export const UNIT_LABELS = {
  hour: 'Heure',
  unit: 'Unité',
  m2: 'm²',
  m3: 'm³',
  ml: 'Ml',
  forfait: 'Forfait',
  day: 'Jour'
};

// Legacy - kept for backward compatibility with QuoteBuilderPage
export const TVA_RATES = [
  { value: 0, label: '0%' },
  { value: 5.5, label: '5,5%' },
  { value: 10, label: '10%' },
  { value: 20, label: '20%' }
];

// Re-export from serviceCategories for components that still use these
export { 
  getCategoryLabel, 
  getUnitLabel 
} from '../config/serviceCategories';
